/* ===== RestockRocket reload gate (Roobear) =====
   RestockRocket reloads the whole PDP on every variant change. Only let that
   reload through when its widget actually shows (sold out / preorder);
   otherwise keep variant switching instant and hide any stale notify button. */
(function () {
  var _setTimeout = window.setTimeout;
  window.setTimeout = function (fn, delay) {
    try {
      if (typeof fn === 'function' &&
          /location\s*\.\s*reload/.test(Function.prototype.toString.call(fn))) {
        var orig = fn, ctx = this;
        return _setTimeout.call(window, function () {
          var idEl = document.querySelector('[name="id"]');
          var id = idEl && idEl.value;
          var v = window.RB_VARIANTS && window.RB_VARIANTS[id];
          var pre = (window._RestockRocketConfig && window._RestockRocketConfig.preorderVariantIds) || [];
          var isPre = pre.indexOf(Number(id)) !== -1 || pre.indexOf(String(id)) !== -1;
          if (!v || v.available === false || isPre) { return orig.apply(ctx, arguments); }
          var btns = document.querySelectorAll('.restock-rocket-button-container');
          for (var i = 0; i < btns.length; i++) { btns[i].style.display = 'none'; }
        }, delay);
      }
    } catch (e) {}
    return _setTimeout.apply(this, arguments);
  };
})();


/*
* Pipeline Theme — Custom JS
*/

(function() {

  // ===== Sticky ATC Bar =====
  (function initStickyATC() {
    var bar = document.getElementById('sticky-atc-bar');
    var trigger = document.getElementById('sticky-atc-trigger');
    var nativeBtn = document.querySelector('[data-native-atc]');
    var stickyMeta = document.getElementById('sticky-atc-meta');
    var stickyPrice = document.getElementById('sticky-atc-price');
    var stickyDot = document.getElementById('sticky-atc-dot');
    var stickyBtnText = document.getElementById('sticky-atc-btn-text');
    var cfg = document.querySelector('[data-rb-add]');

    if (!bar || !nativeBtn) return;

    function cfgText(attr, fallback) {
      return (cfg && cfg.getAttribute(attr)) || fallback;
    }

    /* RestockRocket renders its own "Notify me when available" button beside the
       sold-out add-to-cart. The real click target is the .restock-rocket-button-cover
       overlay sitting on top of the button; clicking either opens the app's modal
       with the current variant already selected. */
    function notifyButton() {
      return document.querySelector('.restock-rocket-button-cover, .restock-rocket-button');
    }

    /* Notify-me can be switched off per variant in the app. If it is, there is
       nothing to send the shopper to, so fall back to the plain sold-out state
       rather than handing them a second dead button. */
    function notifyEnabled() {
      var c = window._RestockRocketConfig;
      var off = c && c.disabledNotifyMeVariantIds;
      if (!off || !off.length) return true;
      var idEl = document.querySelector('[name="id"]');
      var id = idEl && idEl.value;
      return off.indexOf(Number(id)) === -1 && off.indexOf(String(id)) === -1;
    }

    function setStickyState(available) {
      if (!trigger) return;
      var notify = !available && notifyEnabled();
      var label;

      if (available) {
        label = cfgText('data-rb-is-preorder') === '1'
          ? cfgText('data-rb-preorder', 'Add to Cart')
          : cfgText('data-rb-add', 'Add to Cart');
      } else {
        label = notify
          ? cfgText('data-rb-notify', 'Notify me when available')
          : cfgText('data-rb-soldout', 'Sold Out');
      }

      trigger.setAttribute('data-rb-state', notify ? 'notify' : (available ? 'add' : 'soldout'));
      trigger.disabled = !available && !notify;
      if (stickyBtnText) stickyBtnText.textContent = label;
      trigger.setAttribute('aria-label', label);

      // Don't advertise a price on something that can't be bought right now.
      if (stickyPrice) stickyPrice.hidden = !available;
      if (stickyDot) stickyDot.hidden = !available;
    }

    function updateBarVisibility() {
      var rect = nativeBtn.getBoundingClientRect();
      var belowFold = rect.bottom < 0;
      var aboveFold = rect.top > window.innerHeight;
      if (belowFold || aboveFold) {
        bar.classList.add('is-visible');
        bar.setAttribute('aria-hidden', 'false');
      } else {
        bar.classList.remove('is-visible');
        bar.setAttribute('aria-hidden', 'true');
      }
    }

    function updateStickyMeta(variant) {
      if (!stickyMeta) return;
      var parts = [];
      if (variant && variant.title && variant.title !== 'Default Title') {
        parts = variant.title.split(' / ');
      }
      stickyMeta.textContent = parts.join(' · ');
    }

    function updateStickyPrice(price) {
      if (!stickyPrice) return;
      stickyPrice.textContent = Shopify && Shopify.formatMoney
        ? Shopify.formatMoney(price, '{{ amount }}')
        : '$' + (price / 100).toFixed(2);
    }

    if (trigger) {
      trigger.addEventListener('click', function() {
        if (trigger.getAttribute('data-rb-state') === 'notify') {
          var rr = notifyButton();
          if (rr) { rr.click(); return; }
          /* RestockRocket injects its button asynchronously. If it hasn't landed
             yet, put the shopper on the buy box so the notify form is in front
             of them the moment it renders. */
          nativeBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        var realBtn = document.querySelector('[data-add-to-cart]');
        if (realBtn && !realBtn.disabled) {
          realBtn.click();
        }
      });
    }

    document.addEventListener('theme:variant:change', function(event) {
      var variant = event.detail.variant;
      if (!variant) return;
      updateStickyMeta(variant);
      updateStickyPrice(variant.price);
      setStickyState(variant.available !== false);
    });

    var ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          updateBarVisibility();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });

    updateBarVisibility();

    /* Reconcile against the server-rendered buy box on load, then once more after
       RestockRocket has had a chance to publish its per-variant notify config. */
    setStickyState(!nativeBtn.disabled);
    setTimeout(function () { setStickyState(!nativeBtn.disabled); }, 1500);
  })();


  // ===== RB Instant Variant Switch =====
  (function initRBVariant() {
    var RB = window.RB = window.RB || {};

    RB.apply = function(el, id, url) {
      try {
        var V = window.RB_VARIANTS;
        if (!V || !V[id]) return false;
        var v = V[id];
        var root = (el && el.closest && el.closest('[data-section-type="product"]')) || document;

        // Price block. RB_PRICE_HTML is keyed by price/compare-at pair (see
        // snippets/product-price.liquid), so same-priced variants share one entry and
        // the DOM is left untouched when nothing about the price actually changed.
        var priceWrap = root.querySelector('[data-price-wrapper]');
        if (priceWrap && window.RB_PRICE_HTML) {
          var pKey = window.RB_PRICE_KEY && window.RB_PRICE_KEY[id];
          var pHtml = pKey != null ? window.RB_PRICE_HTML[pKey] : null;
          if (pHtml != null && priceWrap.getAttribute('data-rb-price-key') !== pKey) {
            priceWrap.innerHTML = pHtml;
            priceWrap.setAttribute('data-rb-price-key', pKey);
          }
          priceWrap.setAttribute('data-variant-id', id);
        }

        if (window.RB_COUNTDOWN_HTML) {
          var cd = root.querySelector('[data-rb-countdown]');
          if (cd) cd.innerHTML = (window.RB_COUNTDOWN_HTML[id] != null ? window.RB_COUNTDOWN_HTML[id] : '');
        }

        var atc = root.querySelector('[data-add-to-cart]');
        var atcText = root.querySelector('[data-add-to-cart-text]');
        var cfgEl = root.querySelector('[data-rb-add]');
        if (atc) atc.disabled = !v.available;
        if (atcText && cfgEl) {
          var addText = cfgEl.getAttribute('data-rb-add') || 'Add to Cart';
          var soldText = cfgEl.getAttribute('data-rb-soldout') || 'Sold Out';
          var preText = cfgEl.getAttribute('data-rb-preorder') || addText;
          var isPre = cfgEl.getAttribute('data-rb-is-preorder') === '1';
          atcText.textContent = v.available ? (isPre ? preText : addText) : soldText;
        }

        // Use opts, not title.split(' / '): a colour value can itself contain " / "
        // (e.g. "Blue / Cream"), which shifts every later option one slot.
        var parts = v.opts || (v.title || '').split(' / ');
        var wrappers = root.querySelectorAll('[data-option-position]');
        for (var i = 0; i < wrappers.length; i++) {
          var pos = parseInt(wrappers[i].getAttribute('data-option-position'), 10);
          var lbl = wrappers[i].querySelector('[data-option-value]');
          if (lbl && parts[pos - 1] != null) lbl.textContent = parts[pos - 1];
        }

        if (url) { try { window.history.replaceState({}, '', url); } catch (e) {} }

        document.dispatchEvent(new CustomEvent('theme:variant:change', {
          detail: { variant: { id: id, title: v.title, price: v.price, available: v.available } },
          bubbles: true
        }));

        RB.applyOptionStates(root);
        RB.jumpImage(root, v.media);
        return true;
      } catch (e) {
        return false;
      }
    };

    RB.jumpImage = function (root, mediaId) {
      try {
        if (mediaId == null || typeof window.Flickity === 'undefined') return;
        root = root || document;
        var sliders = root.querySelectorAll('.flickity-enabled');
        for (var i = 0; i < sliders.length; i++) {
          var cell = sliders[i].querySelector('[data-media-id="' + mediaId + '"]');
          if (!cell) continue;
          var f = window.Flickity.data(sliders[i]);
          if (f && typeof f.selectCell === 'function') f.selectCell(cell, false, true);
        }
      } catch (e) {}
    };

    RB.preloadImages = function () {
      try {
        var V = window.RB_VARIANTS;
        if (!V) return;
        var root = document.querySelector('[data-section-type="product"]') || document;
        var seen = {};
        var run = function () {
          for (var id in V) {
            if (!V.hasOwnProperty(id)) continue;
            var mid = V[id].media;
            if (mid == null || seen[mid]) continue;
            seen[mid] = 1;
            var slide = root.querySelector('[data-media-id="' + mid + '"]');
            if (!slide) continue;
            var img = slide.tagName === 'IMG' ? slide : slide.querySelector('img');
            if (!img) continue;
            if (img.getAttribute('loading') === 'lazy') img.setAttribute('loading', 'eager');
            var pre = new Image();
            var sizes = img.getAttribute('sizes'); if (sizes) pre.sizes = sizes;
            var ss = img.getAttribute('srcset') || img.getAttribute('data-srcset'); if (ss) pre.srcset = ss;
            var sc = img.getAttribute('src') || img.getAttribute('data-src'); if (sc) pre.src = sc;
          }
        };
        if ('requestIdleCallback' in window) requestIdleCallback(run, { timeout: 2500 });
        else setTimeout(run, 1200);
      } catch (e) {}
    };


    RB.resolveVariant = function(el, overridePos, overrideVal) {
      try {
        var V = window.RB_VARIANTS;
        if (!V) return null;
        var section = (el && el.closest && el.closest('[data-section-type="product"]')) || document;
        var wrapperNodes = section.querySelectorAll('[data-option-position]');
        var wrappers = Array.prototype.slice.call(wrapperNodes).sort(function(a, b) {
          return parseInt(a.getAttribute('data-option-position'), 10) - parseInt(b.getAttribute('data-option-position'), 10);
        });
        if (!wrappers.length) return null;
        var selectedOpts = [];
        for (var i = 0; i < wrappers.length; i++) {
          var pos = parseInt(wrappers[i].getAttribute('data-option-position'), 10);
          if (overridePos && pos === overridePos && overrideVal != null) {
            selectedOpts.push(overrideVal); continue;
          }
          var checked = wrappers[i].querySelector('input[type="radio"]:checked');
          if (checked) { selectedOpts.push(checked.value); continue; }
          var hidden = wrappers[i].querySelector('[data-popout-input]');
          if (hidden) { selectedOpts.push(hidden.value); continue; }
          return null;
        }
        for (var vid in V) {
          if (!V.hasOwnProperty(vid)) continue;
          var vopts = V[vid].opts;
          if (!vopts || vopts.length !== selectedOpts.length) continue;
          var match = true;
          for (var j = 0; j < vopts.length; j++) {
            if (vopts[j] !== selectedOpts[j]) { match = false; break; }
          }
          if (match) return vid;
        }
        return null;
      } catch(e) { return null; }
    };

    /* Re-mark every option value's stock state for the CURRENT combination.
       The Liquid bakes `sold-out` / `unavailable` onto each input at render time
       using `value.variant`, which is only correct for the colour/size that was
       selected when the page was served. Because RB switches variants without a
       section refetch, those classes go stale — e.g. switch off a sold-out
       colour and every size still shows struck through. This recomputes them
       client-side from RB_VARIANTS, matching what a full page load would render.
         sold-out    = the combination exists but is unavailable
         unavailable = no such variant exists
       CSS hooks: `.radio__button .sold-out + label:before`,
       `.swatch__button input.sold-out ~ label:before`, `.select-popout__list .sold-out`. */
    RB.applyOptionStates = function (root) {
      try {
        var V = window.RB_VARIANTS;
        if (!V) return;
        root = root || document.querySelector('[data-section-type="product"]') || document;

        var wrapperNodes = root.querySelectorAll('[data-option-position]');
        if (!wrapperNodes.length) return;
        var wrappers = Array.prototype.slice.call(wrapperNodes).sort(function (a, b) {
          return parseInt(a.getAttribute('data-option-position'), 10) - parseInt(b.getAttribute('data-option-position'), 10);
        });

        // Current selection, indexed by option position - 1 (same order as v.opts).
        var current = [], slots = [];
        for (var i = 0; i < wrappers.length; i++) {
          var slot = parseInt(wrappers[i].getAttribute('data-option-position'), 10) - 1;
          if (isNaN(slot) || slot < 0) return;
          var checked = wrappers[i].querySelector('input[type="radio"]:checked');
          var hidden = checked ? null : wrappers[i].querySelector('[data-popout-input]');
          var val = checked ? checked.value : (hidden ? hidden.value : null);
          if (val == null) return; // can't reason about a partial selection
          current[slot] = val;
          slots[i] = slot;
        }

        // 'ok' | 'sold-out' | 'unavailable' for `value` in `slot`, holding the
        // other options at their current selection.
        function stateFor(slot, value) {
          var exists = false;
          for (var vid in V) {
            if (!V.hasOwnProperty(vid)) continue;
            var opts = V[vid].opts;
            if (!opts || opts.length !== current.length) continue;
            var match = true;
            for (var k = 0; k < opts.length; k++) {
              var want = (k === slot) ? value : current[k];
              if (opts[k] !== want) { match = false; break; }
            }
            if (!match) continue;
            exists = true;
            if (V[vid].available !== false) return 'ok';
          }
          return exists ? 'sold-out' : 'unavailable';
        }

        function mark(el, state) {
          el.classList.toggle('sold-out', state === 'sold-out');
          el.classList.toggle('unavailable', state === 'unavailable');
        }

        for (var w = 0; w < wrappers.length; w++) {
          var inputs = wrappers[w].querySelectorAll('input[type="radio"]');
          for (var n = 0; n < inputs.length; n++) {
            mark(inputs[n], stateFor(slots[w], inputs[n].value));
          }
          var links = wrappers[w].querySelectorAll('.select-popout__option[data-value]');
          for (var m = 0; m < links.length; m++) {
            mark(links[m], stateFor(slots[w], links[m].getAttribute('data-value')));
          }
        }
      } catch (e) {}
    };

    RB.select = function(scope, el, fbId, fbMedia, fbUrl, overridePos, overrideVal) {
      try {
        var id = RB.resolveVariant(el, overridePos, overrideVal);
        var v = id && window.RB_VARIANTS && window.RB_VARIANTS[id];
        if (v && scope) {
          scope.variantId = id;
          if (typeof scope.updateProductImage === 'function') scope.updateProductImage(v.media);
          RB.apply(el, id, location.origin + location.pathname + '?variant=' + id);
          return id;
        }
      } catch (e) {}
      // Fallback: let the theme's own network switch handle it
      if (scope && typeof scope.changeVariant === 'function') scope.changeVariant(fbUrl, fbId, fbMedia);
      return null;
    };

    function rbInit() { RB.preloadImages(); RB.applyOptionStates(); }
    if (document.readyState !== 'loading') rbInit();
    else document.addEventListener('DOMContentLoaded', rbInit);
  })();


  // ===== Patch productForm().changeVariant to prevent section reload =====
  // alpine:initialized fires during theme.js BEFORE custom.js loads, so we patch
  // immediately — Alpine components are already initialised when custom.js runs.
  (function patchChangeVariant() {
    function patch() {
      try {
        var section = document.querySelector('[data-section-type="product"]');
        if (!section) return;
        var xroot = section.querySelector('[x-data]') || section;
        var data = window.Alpine && window.Alpine.$data(xroot);
        if (!data || typeof data.changeVariant !== 'function') return;
        var _orig = data.changeVariant.bind(data);
        data.changeVariant = function(variantUrl, newVariantId, variantMediaId) {
          if (window.RB_VARIANTS && newVariantId != null && window.RB_VARIANTS[newVariantId]) {
            if (this.variantId !== newVariantId) this.variantId = newVariantId;
            if (window.RB && typeof window.RB.apply === 'function') {
              window.RB.apply(null, newVariantId, variantUrl);
            }
            this.updateProductImage(variantMediaId);
            return Promise.resolve();
          }
          return _orig.call(this, variantUrl, newVariantId, variantMediaId);
        };
      } catch (e) {}
    }
    patch();
    document.addEventListener('alpine:initialized', patch);
  })();


  document.addEventListener('theme:variant:change', function(event) {
    var variant = event.detail.variant;
    var container = event.target;
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
  });

  document.addEventListener('theme:cart:init', (e) => {});
  document.addEventListener('theme:scroll', e => {});
  document.addEventListener('theme:resize', e => {});

})();


// ===== OLEN Carriers external link: open in a new tab =====
// Keeps visitors on roobearkids.com when they click the OLEN Carriers menu link.
(function() {
  function markOlenLinks() {
    var links = document.querySelectorAll('a[href*="olencarry.com"]');
    for (var i = 0; i < links.length; i++) {
      links[i].setAttribute('target', '_blank');
      links[i].setAttribute('rel', 'noopener noreferrer');
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', markOlenLinks);
  } else {
    markOlenLinks();
  }
  document.addEventListener('shopify:section:load', markOlenLinks);
})();


// ===== Hide Judge.me reviews tab on mobile =====
// The tab floats at the bottom and covers the sticky ATC bar on small screens.
(function() {
  if (window.innerWidth > 767) return;

  function hideJdgmTab(root) {
    var scope = root || document;
    // Cast wide net: any element whose class or id contains both 'jdgm' and 'tab'
    var candidates = scope.querySelectorAll
      ? scope.querySelectorAll('[class*="jdgm"], [id*="jdgm"]')
      : [];
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      var cls = (el.className || '').toString();
      var id  = el.id || '';
      if (cls.indexOf('tab') > -1 || id.indexOf('tab') > -1) {
        el.style.setProperty('display', 'none', 'important');
      }
    }
    // Also check the root node itself
    if (root && root.nodeType === 1) {
      var rootCls = (root.className || '').toString();
      var rootId  = root.id || '';
      if ((rootCls.indexOf('jdgm') > -1 || rootId.indexOf('jdgm') > -1) &&
          (rootCls.indexOf('tab') > -1  || rootId.indexOf('tab') > -1)) {
        root.style.setProperty('display', 'none', 'important');
      }
    }
  }

  // Run at script parse time and after DOM ready
  hideJdgmTab();
  document.addEventListener('DOMContentLoaded', function() { hideJdgmTab(); });

  // Watch for Judge.me injecting the tab asynchronously
  if (window.MutationObserver) {
    var obs = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          hideJdgmTab(added[j]);
        }
      }
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }
})();

// ===== Size filter → auto "In stock" (Roobear) =====
(function () {
  var SIZE_PARAM = 'filter.v.t.shopify.size';

  function isSizeFacet(input) {
    return input && input.name && input.name.toLowerCase() === SIZE_PARAM;
  }
  function anySizeChecked(form) {
    var boxes = form.querySelectorAll('input[name="' + SIZE_PARAM + '"]');
    for (var i = 0; i < boxes.length; i++) if (boxes[i].checked) return true;
    return false;
  }

  window.addEventListener('change', function (e) {
    var input = e.target;
    if (!isSizeFacet(input)) return;
    var form = input.closest && input.closest('form');
    if (!form) return;

    var inStock  = form.querySelector('input[name="filter.v.availability"][value="1"]');
    var outStock = form.querySelector('input[name="filter.v.availability"][value="0"]');
    if (!inStock) return;
    if (outStock && outStock.checked) return;

    if (anySizeChecked(form)) {
      if (!inStock.checked) {
        inStock.checked = true; inStock.dataset.rbAuto = '1';
        inStock.dispatchEvent(new Event('input', { bubbles: true }));
      }
    } else if (inStock.dataset.rbAuto === '1') {
      inStock.checked = false; delete inStock.dataset.rbAuto;
      inStock.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }, true);

  function reconcileOnLoad() {
    if (!document.querySelector('input[name="filter.v.availability"]')) return;
    var params = new URLSearchParams(window.location.search), hasSize = false, hasAvail = false;
    params.forEach(function (v, k) {
      var key = k.toLowerCase();
      if (key === SIZE_PARAM) hasSize = true;
      if (key === 'filter.v.availability') hasAvail = true;
    });
    if (hasSize && !hasAvail) {
      params.append('filter.v.availability', '1');
      window.location.replace(window.location.pathname + '?' + params.toString() + window.location.hash);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reconcileOnLoad);
  else reconcileOnLoad();
})();
// ===== Hide colour swatches sold out in the filtered size (Roobear) =====
// On collection/search, when a size is filtered, hide colour/pattern swatches on
// each product card whose colour is sold out in that size. Cards don't carry per-
// size stock, so we fetch each multi-colour product's /products/<handle>.js once
// (cached) and cross-check colour × size. Reliable for T-sizes; if a product's size
// names don't match the filter labels (e.g. baby months), that card is left as-is.
(function () {
  var SIZE_PARAM = 'filter.v.t.shopify.size';
  var SWATCH_WRAP = '.product__grid__color__swatches';
  var cache = {};

  function getProduct(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cache[handle];
  }

  function activeSizeLabels() {
    var labels = [];
    var inputs = document.querySelectorAll('input[name="' + SIZE_PARAM + '"]:checked');
    for (var i = 0; i < inputs.length; i++) {
      var lab = inputs[i].id ? document.querySelector('label[for="' + inputs[i].id + '"]') : null;
      var t = ((lab && (lab.getAttribute('aria-label') || lab.textContent)) || '').trim();
      if (t) labels.push(t);
    }
    return labels;
  }

  function handleFromHref(href) {
    var m = href && href.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function optionName(o) { return (typeof o === 'string' ? o : (o && o.name) || '').toLowerCase(); }
  function sizeIndex(options) {
    for (var i = 0; i < options.length; i++) if (optionName(options[i]) === 'size') return i;
    for (var j = 0; j < options.length; j++) if (optionName(options[j]).indexOf('size') > -1) return j;
    return -1;
  }

  function processCard(wrap, sizeLabels) {
    var swatches = wrap.querySelectorAll('radio-swatch');
    if (swatches.length < 2) return; // single colour: nothing to filter

    var items = [];
    for (var i = 0; i < swatches.length; i++) {
      var a = swatches[i].querySelector('a[href]');
      if (!a) continue;
      var handle = handleFromHref(a.getAttribute('href'));
      if (!handle) continue;
      var colour = (a.getAttribute('data-swatch') || swatches[i].getAttribute('title') || a.getAttribute('title') || '').trim();
      items.push({ el: swatches[i], handle: handle, colour: colour });
    }
    if (!items.length) return;

    Promise.all(items.map(function (it) {
      return getProduct(it.handle).then(function (p) { it.product = p; return it; });
    })).then(function (resolved) {
      var hideEls = [], keep = 0;
      for (var k = 0; k < resolved.length; k++) {
        var it = resolved[k], p = it.product;
        if (!p || !p.variants || !p.options) { keep++; continue; }
        var sIdx = sizeIndex(p.options);
        if (sIdx === -1) { keep++; continue; }
        var cIdx = -1;
        for (var oi = 0; oi < p.options.length; oi++) { if (oi !== sIdx) { cIdx = oi; break; } }

        var present = {};
        for (var vi = 0; vi < p.variants.length; vi++) present[p.variants[vi].options[sIdx]] = true;
        var matched = sizeLabels.filter(function (l) { return present[l]; });
        if (!matched.length) { keep++; continue; } // size names don't map → leave alone

        var available = false;
        for (var v = 0; v < p.variants.length; v++) {
          var vv = p.variants[v];
          var colourOk = cIdx === -1 ? true : String(vv.options[cIdx]) === it.colour;
          if (colourOk && vv.available && matched.indexOf(vv.options[sIdx]) > -1) { available = true; break; }
        }
        if (available) keep++; else hideEls.push(it.el);
      }
      if (keep === 0) return; // never hide every swatch
      for (var h = 0; h < hideEls.length; h++) hideEls[h].style.setProperty('display', 'none', 'important');
    });
  }

  // Hide a whole per-colour "variant card" when that colour is sold out in the filtered size.
  function processVariantCards() {
    var vEls = document.querySelectorAll('product-grid-item-variant[data-grid-item-variant]');
    var items = [];
    for (var i = 0; i < vEls.length; i++) {
      var card = vEls[i].closest('product-grid-item') || vEls[i];
      var vid = vEls[i].getAttribute('data-grid-item-variant');
      var a = card.querySelector('a[href*="/products/"]');
      var handle = a ? handleFromHref(a.getAttribute('href')) : null;
      if (vid && handle) items.push({ card: card, vid: vid, handle: handle });
    }
    if (!items.length) return;
    Promise.all(items.map(function (it) {
      return getProduct(it.handle).then(function (p) { it.product = p; return it; });
    })).then(function (resolved) {
      for (var k = 0; k < resolved.length; k++) {
        var it = resolved[k], p = it.product;
        if (!p || !p.variants) continue;
        var anchor = null;
        for (var v = 0; v < p.variants.length; v++) {
          if (String(p.variants[v].id) === String(it.vid)) { anchor = p.variants[v]; break; }
        }
        if (anchor && anchor.available === false) it.card.style.setProperty('display', 'none', 'important');
      }
    });
  }

  function run() {
    var sizeLabels = activeSizeLabels();
    if (!sizeLabels.length) return; // no size filter → fresh DOM already shows all colours
    var wraps = document.querySelectorAll(SWATCH_WRAP);
    for (var i = 0; i < wraps.length; i++) processCard(wraps[i], sizeLabels);
    processVariantCards();
  }

  var t;
  function schedule() { clearTimeout(t); t = setTimeout(run, 250); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();

  var grid = document.querySelector('[data-products-grid]');
  if (window.MutationObserver && grid) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) { schedule(); return; }
      }
    }).observe(grid, { childList: true, subtree: true });
  }
})();